import React from 'react';
import type { IconName } from '~uikit/Icon/icon-names';
import SecondaryButton from '~/components/views/common/buttons/SecondaryButton/SecondaryButton';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import style from './RetryButton.module.pcss';

export interface Props {
  errorMessage: string;
  reloadMessage?: string;
  reloadIcon?: IconName;
  callback(): void;
  testId?: string;
}

const RetryButton: React.FC<Props> = ({
  errorMessage,
  reloadMessage = 'web.error.button.try_again',
  reloadIcon = 'refresh',
  callback,
  testId,
}) => {
  return (
    <div className={style.RetryButton} data-testid={testId}>
      <div className={style.message}>
        <FormattedMessageWrapper langKey={errorMessage} />
      </div>

      <div>
        <SecondaryButton
          langKey={reloadMessage}
          onClick={callback}
          iconLeft={reloadIcon}
          trackingLabel="RetryButton"
        />
      </div>
    </div>
  );
};

export default RetryButton;
